export default __webpack_public_path__ + "static/media/bg-medical.c826d657.jpg";